var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04Behance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.8,0C0.4,0,0,0.4,0,0.8v5.8c0,0.5,0.4,0.8,0.8,0.8h5.8c0.5,0,0.8-0.4,0.8-0.8V0.8C7.5,0.4,7.1,0,6.7,0H0.8z  M1.4,2h1.1c1,0,1.1,0.6,1.1,1c0,0.5-0.4,0.7-0.5,0.8c0.1,0,0.5,0.2,0.5,0.8c0,0.8-0.4,1-1.1,1H1.4V2z M4.3,2h1.5v0.4H4.3V2z  M2.1,2.5v0.9h0.4c0.3,0,0.4-0.1,0.4-0.4c0-0.3-0.1-0.5-0.4-0.5H2.1z M5.2,2.8c0.6,0,1,0.3,1,1.3v0.3H4.8c0,0.1,0,0.6,0.5,0.6 c0.3,0,0.5-0.2,0.6-0.2l0.3,0.4c0,0-0.3,0.4-0.9,0.4c-0.6,0-1.1-0.3-1.1-1.2V4.1C4.2,3.2,4.7,2.8,5.2,2.8z M5.2,3.4 c-0.1,0-0.4,0-0.4,0.5h0.7C5.5,3.9,5.6,3.4,5.2,3.4z M2.1,4v1h0.5C2.8,4.9,3,4.7,3,4.5C3,4.1,2.9,4,2.6,4H2.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04Behance);
export default __webpack_public_path__ + "static/media/04-behance.2969cfb6f514388e72a920a9830b95aa.svg";
export { ForwardRef as ReactComponent };